import {useEffect, useState} from "react";
import {useRouteError} from "react-router";

import ErrorBoundaryOverlay from "./ErrorBoundaryOverlay";
import Loader from "../service/Loader";
import {claimChunkReload, isChunkLoadError} from "../service/ChunkLoadError";

/**
 * `errorElement` des routes : le routeur l'affiche quand le chargement d'un écran échoue, sur l'URL
 * que l'utilisateur visait.
 *
 * Un chunk introuvable signale presque toujours un déploiement survenu pendant que l'onglet était
 * ouvert (cf. `ChunkLoadError.ts`) : on recharge alors la page, une seule fois, ce qui ouvre l'écran
 * visé dans la nouvelle version. Toute autre erreur, ou un échec qui persiste après rechargement,
 * affiche l'écran d'erreur habituel.
 *
 * Les erreurs de rendu des écrans ne passent pas par ici : l'`ErrorBoundary` de `Layout`, plus
 * proche d'eux, les intercepte avant.
 */
const RouteErrorOverlay = () => {
  const error = useRouteError();
  const chunkLoadError = isChunkLoadError(error);
  const [showError, setShowError] = useState(!chunkLoadError);

  // La décision est prise dans l'effet et non au rendu : elle note l'heure du rechargement dans le
  // `sessionStorage`, un effet de bord qu'un rendu rejoué consommerait à vide.
  useEffect(() => {
    if (!chunkLoadError) return;
    if (claimChunkReload(window.sessionStorage, Date.now())) {
      window.location.reload();
    } else {
      setShowError(true);
    }
  }, [chunkLoadError]);

  return showError ? <ErrorBoundaryOverlay error={error} /> : <Loader isOpen />;
};

export default RouteErrorOverlay;
